import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES, FOOTER_CONTENT_MAP } from 'src/constants';
import { useIndustry } from 'src/context';
import './footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const { industry } = useIndustry();
  const { cssStyles, logo, logoText, sections } = FOOTER_CONTENT_MAP[industry];

  const navigateHome = () => {
    navigate(ROUTES.home);
    window.scrollTo(0, 0);
  };

  return (
    <footer className={`footer-container ${cssStyles['footer-container']}`}>
      <div className={`footer ${cssStyles['footer']}`}>
        <div
          className={`branding-container ${cssStyles['branding-container']}`}
        >
          <div className={`logo ${cssStyles['logo']}`} onClick={navigateHome}>
            <img src={logo.src} alt={logo.alt} />
            <span>{logoText}</span>
          </div>
          <div className={`rights ${cssStyles['rights']}`}>
            <span>© 2025 All Rights Reserved</span>
          </div>
        </div>
        <nav className={`nav ${cssStyles['nav']}`}>
          {sections?.map((section, index) => (
            <div key={index} className={`column ${cssStyles['column']}`}>
              <h3>{section.header}</h3>
              {section.navLinks.map((link, idx) => (
                <p key={idx}>{link}</p>
              ))}
            </div>
          ))}
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
